<dx-popup
  [(visible)]="visible"
  [dragEnabled]="false"
  [height]="popupHeight"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [showTitle]="true"
  [title]="popupTitle"
  [width]="700"
  contentTemplate="popupContent">
  <dxi-popup-toolbar-item
    [options]="{ stylingMode: 'outlined', text: ('Abbrechen' | translate), type:'normal', icon:'close', onClick: onCancel }"
    location="after"
    toolbar="bottom"
    widget="dxButton"/>
  <dxi-popup-toolbar-item
    [options]="{ stylingMode: 'outlined', text: ('Speichern' | translate), type:'default', icon:'save', onClick: onSave }"
    location="after"
    toolbar="bottom"
    widget="dxButton"/>
  <dxi-popup-toolbar-item [options]="{
                            stylingMode: 'outlined',
                            icon : fullScreen ? 'collapse' : 'fullscreen',
                            hint: fullScreen ? 'Minimize' : 'Maximize',
                            onClick: toggleFullScreen
                          }"
                          location="after"
                          toolbar="top"
                          widget="dxButton">
  </dxi-popup-toolbar-item>

  <div *dxTemplate="let data of 'popupContent'">
    <div class="container-edit-form">

      <div class="container-edit-field">
        <div class="container-edit-label">{{ 'Name/Kategorie' | translate }}</div>
        <div class="container-edit-value">
          <dx-text-box [(value)]="container.name"/>
        </div>
      </div>

      <div class="container-edit-field">
        <div class="container-edit-label">{{ 'Lieferant' | translate }}</div>
        <div class="container-edit-value" style="display:flex;flex-direction:row;align-items:center;gap:4px;">
          <dx-select-box [(value)]="container.dataSourceId"
                         [items]="suppliers"
                         [searchEnabled]="true"
                         displayExpr="name"
                         style="flex-grow:1;"
                         valueExpr="id"/>
          <dx-button (onClick)="showEditOfSupplier()" *ngIf="container.dataSourceId" icon="edit"/>
          <dx-button (onClick)="showCreationOfSupplier()" icon="plus"/>
        </div>
      </div>

      <ng-container *ngIf="containerType !== 'export'">

        <div class="container-edit-field">
          <div class="container-edit-label">{{ 'Container-Tags' | translate }}</div>
          <div class="container-edit-value">
            <dx-tag-box (onCustomItemCreating)="addDataSourceTag($event)"
                        [(value)]="importContainer.dataSourceTags"
                        [acceptCustomValue]="true"
                        [items]="dataSourceTagOptions"
                        [searchEnabled]="true"
                        [showSelectionControls]="true"
                        stylingMode="outlined"/>
          </div>
        </div>

        <div class="container-edit-field container-edit-field--logo">
          <div class="container-edit-label">{{ 'Logo' | translate }}</div>
          <div class="container-edit-value">
            <div *ngIf="container.logoLink" class="container-edit-logo-preview-wrapper">
              <img [src]="container.logoLink" class="container-edit-logo-preview" alt="Logo"/>
              <dx-button
                class="container-edit-logo-remove"
                icon="close"
                stylingMode="text"
                type="danger"
                hint="{{ 'Logo entfernen' | translate }}"
                (onClick)="container.logoLink = null">
              </dx-button>
            </div>
            <div class="container-edit-uploader-row">
              <dx-file-uploader
                [dropZone]="dropZoneTarget"
                [uploadMode]="'instantly'"
                [uploadUrl]="uploadUrl"
                accept="image/jpeg,image/png,image/svg+xml,image/webp,image/gif"
                [allowedFileExtensions]="['.jpg','.jpeg','.png','.svg','.webp','.gif']"
                labelText=""
                selectButtonText="{{ 'Datei auswählen' | translate }}"
                (onBeforeSend)="onBeforeSendUpload($event)"
                (onUploaded)="onUploaded($event)"
                (onValueChanged)="onFileSelected($event)"
                (onDropZoneEnter)="isDragOver = true"
                (onDropZoneLeave)="isDragOver = false"
                invalidFileExtensionMessage="{{ 'Ungültiges Dateiformat. Erlaubt: JPG, PNG, SVG, WEBP, GIF' | translate }}"
              />
              <div #dropZoneTarget
                   class="container-edit-drop-target"
                   [class.container-edit-drop-target--over]="isDragOver">
                <span class="dx-icon-image container-edit-drop-icon"></span>
                <span>{{ 'oder hierher ziehen' | translate }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="container-edit-section-title">{{ 'Verantwortlich' | translate }}</div>

        <div class="container-edit-field">
          <div class="container-edit-label">{{ 'Vorname' | translate }}</div>
          <div class="container-edit-value">
            <dx-text-box [(value)]="importContainer.responsibleFirstName"/>
          </div>
        </div>

        <div class="container-edit-field">
          <div class="container-edit-label">{{ 'Name' | translate }}</div>
          <div class="container-edit-value">
            <dx-text-box [(value)]="importContainer.responsibleLastName"/>
          </div>
        </div>

        <div class="container-edit-field">
          <div class="container-edit-label">{{ 'Telefonnummer' | translate }}</div>
          <div class="container-edit-value">
            <dx-text-box [(value)]="importContainer.responsiblePhone"/>
          </div>
        </div>

        <div class="container-edit-field">
          <div class="container-edit-label">{{ 'Email' | translate }}</div>
          <div class="container-edit-value">
            <dx-text-box [(value)]="importContainer.responsibleEmail"/>
          </div>
        </div>

      </ng-container>

    </div>
  </div>
</dx-popup>

<np-edit-datasource (saved)="onSupplierSaved($event)"
                    [(visible)]="supplierEditVisible"
                    [dataSource]="selectedSupplier"
                    [editMode]="supplierEditMode"/>
